


































import Vue from 'vue';
import { Loading } from '@descomplica/vue-components';
import Modal from './Modal.vue';
import SearchCard, { CardInfo } from '../SearchCard/SearchCard.vue';
import { Campus, City } from '@/store/modules/location/state';
import SentryClient from '@/helpers/sentry';

interface Data {
  isLoadingCities: boolean;
  isLoadingCampi: boolean;
  isSubmitting: boolean;
  selectedCity?: City;
}

export default Vue.extend({
  components: { Modal, SearchCard, Loading },
  data(): Data {
    return {
      isLoadingCities: true,
      isLoadingCampi: false,
      isSubmitting: false,
      selectedCity: undefined,
    };
  },
  computed: {
    cities(): City[] {
      return this.$store.getters.availableCities;
    },
    citiesItems(): CardInfo[] {
      return this.cities.map(({ city, state }: City, index: number) => ({
        key: index,
        content: { title: `${city}, ${state}`, icon: 'location' },
      }));
    },
    campi(): Campus[] {
      return this.$store.getters.availableCampuses;
    },
    campiItems(): CardInfo[] {
      return this.campi.map(campus => {
        return {
          key: campus.id,
          content: {
            title: campus.name,
            data: [{ text: campus?.address }] as any,
          },
        };
      });
    },
    isLoading(): boolean {
      return this.isLoadingCities || this.isLoadingCampi || this.isSubmitting;
    },
    showCitiesForm(): boolean {
      return !this.isLoadingCities && !this.selectedCity;
    },
    showCampiForm(): boolean {
      return !this.isLoadingCampi && !!this.selectedCity;
    },
  },
  async mounted(): Promise<void> {
    try {
      await this.$store.dispatch('PULL_AVAILABLE_CITIES');
    } catch (error) {
      this.$emit('error', 'changeCampusError.couldntLoadCities');
      SentryClient.captureError(error as any);
      this.closeModal();
    } finally {
      this.isLoadingCities = false;
    }
  },
  methods: {
    async selectCity(selectedItem: CardInfo): Promise<void> {
      const city = this.cities[selectedItem.key];
      this.selectedCity = city;
      this.isLoadingCampi = true;

      try {
        this.$store.dispatch('UPDATE_CITY', { city });
        await this.$store.dispatch('PULL_AVAILABLE_CAMPUSES');
      } catch (error) {
        this.$emit('error', 'changeCampusError.couldntLoadCampus');
        SentryClient.captureError(error as any);
        this.closeModal();
      } finally {
        this.isLoadingCampi = false;
      }
    },
    async selectCampus(selectedItem: CardInfo): Promise<void> {
      const campus = this.campi.find(campus => campus.id === selectedItem.key);

      this.isSubmitting = true;

      try {
        await this.$store.dispatch('UPDATE_CAMPUS', { campus });
      } catch (error) {
        this.$emit('error', 'changeCampusError.couldntChangeCampus');
        SentryClient.captureError(error as any);
        this.closeModal();
      } finally {
        this.isSubmitting = false;
        this.closeModal();
      }
    },
    closeModal(): void {
      this.$emit('closeModal');
    },
  },
});
